import { PropsWithChildren } from 'react';
import { useParams } from 'react-router-dom';

import { useSitesSso } from '@newfold/huapi-js';
import { SitesSsoParams } from '@newfold/huapi-js/src/index.schemas';

import { useSiteContext } from '~/scenes/Site';

import SSOComponent from '../index';
import { SSO_HOOK_OPTIONS, useDisabledState } from '../utils/helpers';
import { BaseSsoProps } from '../utils/types';

interface SiteSSoProps extends BaseSsoProps {
  siteId?: string | number;
  userId?: number;
  addonId?: number | string;
  siteType?: string;
}

const SiteSSO = ({
  children = undefined,
  siteId: propSiteId = undefined,
  userId = undefined,
  addonId = undefined,
  siteType = 'wordpress',
  queryParams = {},
  disabled = undefined,
  ...props
}: PropsWithChildren<SiteSSoProps>) => {
  const { siteId: paramsSiteId } = useParams();
  const siteId = propSiteId || paramsSiteId;
  const { isDisabled: siteDisabled } = useSiteContext();

  const isDisabled = useDisabledState(disabled, siteDisabled);

  const sso = useSitesSso(
    Number(siteId),
    {
      ...(queryParams && ({ bounce_name: queryParams?.app } as SitesSsoParams)),
      ...(userId && { user_id: String(userId) }),
      ...(addonId && { addon_id: String(addonId) }),
    },
    SSO_HOOK_OPTIONS,
  );

  return (
    <SSOComponent sso={sso} isDisabled={isDisabled} siteId={siteId} {...props}>
      {children}
    </SSOComponent>
  );
};

export default SiteSSO;
